import { CustomerRole } from '@npco/mp-gql-types'
import { useLoggedInUser } from '@npco/mp-utils-logged-in-user'

export const useAccountsIsAllowed = () => {
  const { userRole } = useLoggedInUser()
  const isAdmin = userRole === CustomerRole.ADMIN
  return isAdmin
}
